'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _reactRouterDom = require('react-router-dom');

var _reactRouterRedux = require('react-router-redux');

var _history = require('./history');

var _history2 = _interopRequireDefault(_history);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _load = require('I18n/load');

var _load2 = _interopRequireDefault(_load);

var _http = require('./http');

var _handlers = require('q/js/handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(0, _handlers.logQPromiseIssuesAndSendAlerts)();

var App = function () {
  function App() {
    _classCallCheck(this, App);
  }

  _createClass(App, [{
    key: 'start',
    value: function start() {
      var _this = this;

      if (window.jasmine) return;
      window.AppInstance = this;

      _http.noAuth.get('growthhub/v1/payloads/bootstrap').then(function (bootstrap) {
        return (0, _load2.default)({ langEnabled: true, locale: (bootstrap.authedUser || {}).locale || 'en' }).then(function () {
          _this.store = (0, _store2.default)(_history2.default);
          _this.store.dispatch((0, _actions.createAction)(_actions2.default.BOOTSTRAPPED, bootstrap));

          var switches = _routes2.default.map(function (route, i) {
            return _react2.default.createElement(_reactRouterDom.Route, _extends({}, route, { key: i }));
          });
          (0, _reactDom.render)(_react2.default.createElement(
            _reactRedux.Provider,
            { store: _this.store },
            _react2.default.createElement(
              _reactRouterRedux.ConnectedRouter,
              { history: _history2.default },
              _react2.default.createElement(
                _reactRouterDom.Switch,
                null,
                switches
              )
            )
          ), document.getElementsByClassName('page')[0]);
        });
      });
    }
  }]);

  return App;
}();

var app = new App();
app.start();

exports.default = app;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 100
// module chunks = 0